<template>
  <section class="container">
    <ul class="accordion">
      <li v-if="Object.keys(item.movement).length">
        <button type="button" id="title-movement" :aria-expanded="active === 0 ? 'true' : 'false'" aria-controls="body-movement" @click="switchTab(0)">
          <i class="icon-movement"></i>
          <h3 class="h6 -upper">{{ $t('Movement') }}</h3>
        </button>
        <transition-expand>
          <div v-show="active === 0" id="body-movement" role="region" aria-labelledby="title-movement">
            <table :aria-describedby="$t('Table') + ': ' + $t('Movement')">
              <tr v-for="(v, n) in item.movement" :key="n">
                <th scope="row">{{ $t(n) }}</th>
                <td>{{ v }}</td>
              </tr>
            </table>
          </div>
        </transition-expand>
      </li>
      <li v-if="Object.keys(item.function).length">
        <button type="button" id="title-function" :aria-expanded="active === 1 ? 'true' : 'false'" aria-controls="body-function" @click="switchTab(1)">
          <i class="icon-function"></i>
          <h3 class="h6 -upper">{{ $t('Functions') }}</h3>
        </button>
        <transition-expand>
          <div v-if="active === 1" id="body-function" role="region" aria-labelledby="title-function">
            <table :aria-describedby="$t('Table') + ': ' + $t('Functions')">
              <tr v-for="(f, i) in item.function" :key="i">
                <td scope="row">{{ f }}</td>
              </tr>
            </table>
          </div>
        </transition-expand>
      </li>
      <li v-if="Object.keys(item.case).length">
        <button type="button" id="title-case" :aria-expanded="active === 2 ? 'true' : 'false'" aria-controls="body-case" @click="switchTab(2)">
          <i class="icon-case"></i>
          <h3 class="h6 -upper">{{ $t('Case') }}</h3>
        </button>
        <transition-expand>
          <div v-if="active === 2" id="body-case" role="region" aria-labelledby="title-case">
            <table :aria-describedby="$t('Table') + ': ' + $t('Case')">
              <template v-for="(v, n) in item.case">
              <tr v-if="v.length" :key="n">
                <th scope="row">{{ $t(n) }}</th>
                <td>{{ v }}</td>
              </tr>
              </template>
            </table>
          </div>
        </transition-expand>
      </li>
      <li v-if="Object.keys(item.strap).length">
        <button type="button" id="title-strap" :aria-expanded="active === 3 ? 'true' : 'false'" aria-controls="body-strap" @click="switchTab(3)">
          <i class="icon-strap"></i>
          <h3 class="h6 -upper">{{ $t('Strap') }}</h3>
        </button>
        <transition-expand>
          <div v-if="active === 3" id="body-strap" role="region" aria-labelledby="title-strap">
            <table :aria-describedby="$t('Table') + ': ' + $t('Strap')">
              <tr v-for="strapSpecification in item.strap" :key="strapSpecification.label">
                <th scope="row">{{ $t(strapSpecification.label) }}</th>
                <td>{{ strapSpecification.value }}</td>
              </tr>
            </table>
          </div>
        </transition-expand>
      </li>
      <li v-if="Object.keys(item.gemsettings).length">
        <button type="button" id="title-gemsettings" :aria-expanded="active === 4 ? 'true' : 'false'" aria-controls="body-gemsettings" @click="switchTab(4)">
          <i class="icon-gemsettings"></i>
          <h3 class="h6 -upper">{{ $t('gemsettings') }}</h3>
        </button>
        <transition-expand>
          <div v-if="active === 4" id="body-gemsettings" role="region" aria-labelledby="title-gemsettings">
            <table :aria-describedby="$t('Table') + ': ' + $t('gemsettings')">
              <template v-for="(v, n) in item.gemsettings">
              <tr v-if="v.length" :key="n">
                <th scope="row">{{ $t('Stones') + ' (' + $t(n) + ')' }}</th>
                <td>{{ v }}</td>
              </tr>
              </template>
            </table>
          </div>
        </transition-expand>
      </li>
    </ul>
    <div class="btn-sheet" v-if="item.pdf">
      <button class="btn" @click="onClick($event, item)">{{ $t('Download product sheet') }}</button>
      <!-- <a v-if="item.pdf" :href="fileUrl + item.pdf" target="_blank" rel="nofollow noreferrer noopener" class="btn" @click="callGTM">{{ $t('Download product sheet') }}</a> -->
    </div>
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import config from 'config'
export default {
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  name: 'technical_specification',
  mixins: [ReadyHook],
  data() {
    return {
      active: -1,
    }
  },
  computed: {
    fileUrl() {
      return config.magento2.fileUrl
    },
  },
  methods: {
    onClick($event, item) {
      $event.preventDefault()
      window.open(item.pdf, '_blank')
      this.callGTM()
    },
    switchTab(v) {
      this.active = this.active === v ? -1 : v
      let interactionType = ['Movement', 'Functions', 'Case', 'Strap', 'Gemsettings']
      this.$gtm.trackEvent({
        event: 'productFeature',
        interactionType: interactionType[v],
        value: this.active !== -1,
      })
    },
    callGTM() {
      this.$gtm.trackEvent({
        event: 'download',
        productName: this.$route.params.uid,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  margin-top: 6rem;
  margin-bottom: 6rem;
  color: var(--zenith-component-text);
}

.accordion {
  margin: 0 auto;
  padding: 0;
  max-width: 110rem;
  list-style: none;
  border-bottom: 1px solid var(--zenith-border);

  .h6 {
    color: var(--zenith-component-text);
  }
  @include bp(max md) {
    margin: 0 -1.5rem;
  }

  #body-function {
    table {
      tr {
        td {
          white-space: pre-line;
        }
      }
    }
  }

  button {
    position: relative;
    display: flex;
    width: 100%;
    padding: 0;

    height: 7rem;
    align-items: center;
    justify-content: space-between;
    border: none;
    background: none;
    border-top: 1px solid var(--zenith-border);
    color: var(--zenith-component-text);

    @include bp(max md) {
      padding: 0 1.5rem;
    }

    i {
      font-size: em(40, 16);
      margin-right: 3.4rem;

      @include bp(max md) {
        margin-right: 2rem;
      }
    }

    h3 {
      margin-bottom: 0;
      margin-right: auto;
    }

    &:after {
      font-family: 'zenith', sans-serif !important;
      speak: none;
      line-height: 1;
      font-size: em(30);
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;

      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      content: '\e909';
      transform: rotate(0);
      transition: all 0.2s ease-in-out;
    }

    &[aria-expanded='false']:after {
      transform: rotate(-45deg);
    }
  }

  table {
    width: auto;
    margin: 1rem 2rem 1rem 7rem;

    @include bp(max md) {
      margin: 0 2rem 1rem 7rem;
    }

    td,
    th {
      width: 100%;
      font-weight: normal;
      padding-bottom: 2rem;
    }
    th:first-child {
      width: auto;
      white-space: nowrap;
      padding-right: 4rem;
      text-transform: uppercase;
    }
  }

  div[role='region'] {
    div {
      margin: 1rem 2rem 3rem 9.4rem;

      @include bp(max md) {
        margin: 0 2rem 3rem 7.5rem;
      }
    }
  }
}

.btn-sheet {
  width: 100%;
  text-align: center;

  .btn {
    margin: 3rem 0;
  }
}
</style>
